import { MainPageContent } from "@/routes/_components/main-page";
import { ProcessesListTable } from "./_components/processes-list-table";

export function ProcessesRoute() {
  return (
    <MainPageContent className="grid grid-cols-1 gap-6">
      <ProcessesListTable />
    </MainPageContent>
  );
}
